<template>
    <fieldset>
        <p>
            OBS! Det är ej lämpligt att koppla fler än en integration av denna
            typ till en profil.
        </p>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Använd egna API-nycklar</div>
            </div>
            <input
                type="checkbox"
                class="ml-3 align-self-center"
                v-model="useOwnKeys"
                style="width: 20px; height: 20px"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Miljö</div>
            </div>
            <select
                class="custom-select"
                v-model="environment"
                @change="onUpdate"
            >
                <option
                    v-for="option in environmentOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
        </div>

        <div class="input-group mb-3" v-if="useOwnKeys">
            <div class="input-group-prepend">
                <div class="input-group-text">Merchant ID</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="merchantId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3" v-if="useOwnKeys">
            <div class="input-group-prepend">
                <div class="input-group-text">Public key</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="publicKey"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3" v-if="useOwnKeys">
            <div class="input-group-prepend">
                <div class="input-group-text">Secret key</div>
            </div>
            <input
                type="password"
                class="form-control"
                required
                v-model="secret"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    Använd som förvalt alternativ i checkout
                </div>
            </div>
            <input
                type="checkbox"
                class="ml-3 align-self-center"
                v-model="defaultMode"
                style="width: 20px; height: 20px"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Banknamn</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldBankName"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Clearing</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldClearing"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Kontonummer</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldAccountNumber"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const useOwnKeys = ref(false);
const environment = ref("production");
const merchantId = ref(null);
const publicKey = ref(null);
const secret = ref(null);
const defaultMode = ref(false);
const fieldBankName = ref(null);
const fieldClearing = ref(null);
const fieldAccountNumber = ref(null);
const environmentOptions = computed(() => {
  return [{
    value: "production",
    label: "Produktionsmiljö"
  }, {
    value: "playground",
    label: "Testmiljö"
  }];
});
const serializedValue = computed(() => {
  return {
    use_own_keys: useOwnKeys.value,
    environment: environment.value,
    merchant_id: merchantId.value,
    public_key: publicKey.value,
    secret: secret.value,
    default_mode: defaultMode.value,
    field_bank_name: fieldBankName.value,
    field_clearing: fieldClearing.value,
    field_account_number: fieldAccountNumber.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    useOwnKeys.value = !!modelValue.value.use_own_keys;
    environment.value = modelValue.value.environment || "production";
    merchantId.value = modelValue.value.merchant_id;
    publicKey.value = modelValue.value.public_key;
    secret.value = modelValue.value.secret;
    defaultMode.value = modelValue.value.default_mode;
    fieldBankName.value = modelValue.value.field_bank_name;
    fieldClearing.value = modelValue.value.field_clearing;
    fieldAccountNumber.value = modelValue.value.field_account_number;
  }
}, {
  immediate: true
});
watch(defaultMode, () => {
    emit("update:modelValue", serializedValue.value);
});
watch(useOwnKeys, () => {
    emit("update:modelValue", serializedValue.value);
});
</script>
